/*
 GLOBAL FUNCTIONALITY:
 1. ISI (scroll events and click events)
 2. Overlays
 3. Toggle navigation
 */

 nav = {
	init: function(){
		$html = document.getElementsByTagName('html')[0];
		nav.cE();
	},
	cE: function cacheElements(){
		/*
		 * cache elements that get reused. keep your code DRY!
		 */
		nav.navOpenButton = document.querySelector(".btn-nav-open");
        nav.mobileNavLinks = $('.mobile-link');
        nav.mobileBackBtn = $('.back-btn');
		nav.body = $("body");

		// DESKTOP HOVER MENU
		nav.navBarLinks = $(".link-with-arrows");
        nav.subNavLinks = $(".sub-link > a");
        nav.subNav      = $('.nav-link-section-wrapper');

		nav.el();
		nav.sE();
		nav.rE();
	},
	el: function eventListenters(){
		 // CLICK EVENT FOR NAV HAMBURGER BUTTON
        nav.navOpenButton.addEventListener("click", function(e){
            nav.toggleNavigation(e);
        });
		/**
		 DESKTOP NAVIGATION EVENT LISTENERS
		 **/

		// If width is larger than 980px (desktop size) and it isn't an iPad then add hover events to navigation
		if (gliv.returnWindowWidth() > 980) {
			// HOVER EVENT FOR DESKTOP NAVIGATION
			nav.hoverEvents();
            // CLOSE SUBNAV BY MOVING MOUSE OUTSIDE OF SUB NAV BOX
            nav.closeEvents();
            // CLOSE SUBNAV IF USER CLICKS ANYWHERE BESIDES THIS SUBNAV OR LINK-WITH-ARROWS IN NAVBAR
            nav.closeOnClickEvents();
            // CLOSE SUBNAV IF USER ENTERS MEET THE GOAL GETTERS, LOGO OR UTILITY NAV IN NAVBAR
            $('.link-without-arrows, .btn-logo, .utility-nav').on('mouseenter', function (e) {
                e.preventDefault();
                nav.hideSubMenu();
                nav.setTabOrder(true);
            });
		} else if (gliv.returnWindowWidth() < 651) {
            $.each(nav.mobileNavLinks, function(){
                $(this).on('click', function(e){
                   e.preventDefault();
                   let menuToOpen = $(this).data('menu');
                   $('#'+menuToOpen).addClass('show-menu-block');
                   $('.mobile-menu-block').addClass('hide');
                });
            });
            $.each(nav.mobileBackBtn, function(){
                $(this).on('click', function(e){
                    e.preventDefault();
                    let menuToClose = $(this).data('menu');
                    $('#'+menuToClose).removeClass('show-menu-block');
                    $('.mobile-menu-block').removeClass('hide');
                });
            });
        }
        $('window').on('load', nav.checkMenuItemOffset());
	},
	sE: function scrollEvents(){
		// SCROLL EVENT FOR ISI
		$(window).on('scroll', function(){
			// if subnav/hovernav is showing, hide it
			if($('.showing--menu')){
				$('.showing--menu').removeClass('showing--menu');
				nav.removeBodyClass();
				$('.nav-link-section-wrapper.show').removeClass('show');
			}
		});
	},
	rE: function resizeEvents(){
		window.addEventListener('resize', function () {
			//Chrome specific bug that causes the resize event to be triggered when the print window is closed, which in turn causes the shadow div to resize to 0 and then the isi cannot open.
			var isChrome = !!window.chrome && !!window.chrome.webstore;
			if (isChrome && $html.classList.contains('print-btn-clicked')){

			} else {
				nav.checkMenuItemOffset()
			}

			// If width is larger than 980px (desktop size) and it isn't an iPad then add hover events to navigation
			if (gliv.returnWindowWidth() > 980) {
				if (nav.body.hasClass("show-main-navigation")){
					nav.body.removeClass("show-main-navigation");
				}
                // HOVER EVENT FOR DESKTOP NAVIGATION
                nav.hoverEvents();
                // CLOSE SUBNAV BY MOVING MOUSE OUTSIDE OF SUB NAV BOX
                nav.closeEvents();
                // CLOSE SUBNAV IF USER CLICKS ANYWHERE BESIDES THIS SUBNAV OR LINK-WITH-ARROWS IN NAVBAR
                nav.closeOnClickEvents();
			} else {
				if (nav.body.hasClass('show-hover-navigation')){
					nav.hideSubMenu();
				}
			}
		});
	},
     hoverEvents: function(){
         $.each(nav.navBarLinks, function () {
             $(this).on('mouseenter', function (e) {
                 e.preventDefault();
                 let subnav = $(this).data('hovermenuid');
                 if ($('body').hasClass('show-hover-navigation') && !$('#'+subnav).hasClass('show') && !$(this).hasClass('showing--menu')) {
                     nav.hideSubMenu();
                     nav.setTabOrder(true);
                     $(this).addClass('showing--menu');
                     nav.showSubMenu(subnav);
                     nav.setTabOrder(false, subnav)
                 } else if($('body').hasClass('show-hover-navigation') && $('#'+subnav).hasClass('show') && $(this).hasClass('showing--menu')){
                     nav.hideSubMenu();
                     nav.setTabOrder(true);
                 } else {
                     $(this).addClass('showing--menu');
                     nav.showSubMenu(subnav);
                     nav.setTabOrder(false, subnav);
                 }
             });
         });
     },
     closeEvents: function(){
         $(nav.subNav).each(function(){
             $(this).on('mouseleave', function (e) {
                 e.preventDefault();
                 nav.hideSubMenu();
                 nav.setTabOrder(true);
             });
         });
     },
     closeOnClickEvents: function(){
         $(document).on('click', function(e) {
             if ($('body').hasClass('show-hover-navigation') && !$(e.target).closest('.nav-link-section-wrapper').length && !$(e.target).closest('.link-with-arrows').length) {
                 nav.hideSubMenu();
                 nav.setTabOrder(true);
             }
         });
     },
	toggleNavigation: function(evt){
		if ($html.classList.contains('show-isi')){
			$html.classList.remove("show-isi");
			$('.main-footer').removeClass('is--open');
		}
		if ($(".isi--is--detached")){
			$html.classList.remove("isi--is--detached");
			nav.body.animate({scrollTop:0}, 100);
		}
		if ($('.svg-transform').attr('transform') === ""){
			nav.addSVGtransform();
		} else {
			nav.removeSVGtransform();
		}
		nav.body.toggleClass("show-main-navigation");
		$('.full-menu').animate({scrollTop:0}, 1000);
		evt.preventDefault();
	},
	addSVGtransform: function addSVGtransform(){
		$('#bottom-bar').attr('transform', 'translate(-12.109863281 8.9455729) rotate(-45 0 0)');
		$('#top-bar').attr('transform', 'translate(7.109863281 2) rotate(45 0 0)');
		$('#middle-bar').css('display', 'none');
	},
	removeSVGtransform: function removeSVGtransform(){
		$('#bottom-bar').attr('transform', '');
		$('#top-bar').attr('transform', '');
		$('#middle-bar').css('display', 'block');
	},
	/**
	 DESKTOP NAVIGATION HOVER FUNCTIONS
	 **/
	showSubMenu: function(menuid){
		if ($(".show")){
			nav.hideMenu();
		}
		if ($('.show-main-navigation')){
			nav.body.removeClass("show-main-navigation");
			nav.removeSVGtransform();
		}
		nav.showMenu(menuid);
		nav.addBodyClass();
	},
	checkMenuItemOffset: function(){
		$.each(nav.navBarLinks, function(){
			var hoverMenuId = $(this).data('hovermenuid');
			var offsetWithoutPx = nav.getNavLinkOffsetLeft(this);
			var offsetNew = offsetWithoutPx + 'px';
			$('#'+hoverMenuId).css('left', offsetNew);
		});
	},
	hideSubMenu: function(){
		$('.showing--menu').removeClass('showing--menu');
		nav.removeBodyClass();
		nav.hideMenu();
	},
	showMenu: function showMenu(menuid) {
		var currentMenu = '#'+menuid;
		$(currentMenu).addClass('show');
	},
	hideMenu: function hideMenu() {
		$('.show').removeClass('show');
	},
	addBodyClass: function addBodyClass(){
		nav.body.addClass("show-hover-navigation");
	},
	removeBodyClass: function removeBodyClass(){
		nav.body.removeClass("show-hover-navigation");
	},
	getNavLinkOffsetLeft: function getNavLinkOffsetLeft(link){
		var offset = $(link).offset();
		return offset.left;
	},
     setTabOrder: function(removeOrder, subnav){
         if (subnav === "understanding-menu"){
             tIndex = 6;
             $('[data-hovermenuid="understanding-menu"] > a').attr('tabindex', 5);
             $('[data-hovermenuid="discovering-livalo-menu"] > a').attr('tabindex', 13);
             $('[data-hovermenuid="starting-livalo-menu"] > a').attr('tabindex', 14);
             $('[data-hovermenuid="supporting-you-on-livalo-menu"] > a').attr('tabindex', 15);
             $('#goal-getters-menu-link > a').attr('tabindex', 16);
         } else if(subnav === "discovering-livalo-menu"){
             tIndex = 7;
             $('[data-hovermenuid="discovering-livalo-menu"] > a').attr('tabindex', 6);
             $('[data-hovermenuid="starting-livalo-menu"] > a').attr('tabindex', 11);
             $('[data-hovermenuid="supporting-you-on-livalo-menu"] > a').attr('tabindex', 12);
             $('#goal-getters-menu-link > a').attr('tabindex', 13);
         } else if(subnav === "starting-livalo-menu"){
             tIndex = 8;
             $('[data-hovermenuid="starting-livalo-menu"] > a').attr('tabindex', 7);
             $('[data-hovermenuid="supporting-you-on-livalo-menu"] > a').attr('tabindex', 13);
             $('#goal-getters-menu-link > a').attr('tabindex', 14);
         } else {
             tIndex = 9;
             $('[data-hovermenuid="supporting-you-on-livalo-menu"] > a').attr('tabindex', 8);
             $('#goal-getters-menu-link > a').attr('tabindex', 14);
         }

         if(removeOrder){
             $.each(nav.subNavLinks, function(){
                 $(this).attr('tabindex', 0);
             });
         } else if(subnav === "understanding-menu"){
             $.each($('#understanding-menu .sub-link > a'), function(){
                 $(this).attr('tabindex', tIndex);
                 tIndex++;
             });
         } else if(subnav === "discovering-livalo-menu"){
             $.each($('#discovering-livalo-menu .sub-link > a'), function(){
                 $(this).attr('tabindex', tIndex);
                 tIndex++;
             });
         } else if(subnav === "starting-livalo-menu"){
             $.each($('#starting-livalo-menu .sub-link > a'), function(){
                 $(this).attr('tabindex', tIndex);
                 tIndex++;
             });
         } else if(subnav === "supporting-you-on-livalo-menu"){
             $.each($('#supporting-you-on-livalo-menu .sub-link > a'), function(){
                 $(this).attr('tabindex', tIndex);
                 tIndex++;
             });
         }
     },
};
